export const THIS_WEEK = 'This week';
export const LAST_WEEK = 'Last week';
export const THIS_SCHOOL_YEAR = 'This school year';
export const CUSTOM_DATE = 'Custom date';
export const CUSTOM_DATE_TIME = 'Date and Time';
export const LIFETIME = 'Lifetime';

export const DEFAULT_DATE_OPTIONS = [
    THIS_WEEK,
    LAST_WEEK,
    THIS_SCHOOL_YEAR,
    CUSTOM_DATE
];
export const DATE_OPTIONS = [
    ...DEFAULT_DATE_OPTIONS,
    CUSTOM_DATE_TIME,
    LIFETIME
];

export const DEFAULT_DATE_OPTIONS_LABELS = {
    [THIS_WEEK]: THIS_WEEK,
    [LAST_WEEK]: LAST_WEEK,
    [THIS_SCHOOL_YEAR]: THIS_SCHOOL_YEAR,
    [CUSTOM_DATE]: CUSTOM_DATE
};



// WEBPACK FOOTER //
// ./app/components/date-picker/date-picker-constants.js